export const RESOURCE_CATALOG_NAMESPACE = ['resource', 'catalog'];
